import React, { Component } from 'react';
import { connect } from "react-redux";
import { functionalSkills } from '../../../modules/functional_skills';
import FunctionalSkillCard from '../../components/functional-skill-card/functional-skill-card';
import FunctionalSkillsLoad from './functional-skills-load';
class FunctionalSkillsSwimlane extends Component{
    constructor(props){
        super(props)
        this.state = {offset: 0};
    }
    componentDidMount(){
        const{token, dispatch} = this.props;
        dispatch(functionalSkills(token))
    }
    scrollRightButton(blockScroll){
        const {offset} = this.state
        const {functionalSkills} = this.props;
        return(
            <div className="tw-text-5xl tw-h-52 tw-w-16 tw-text-gray-300 hover:tw-text-gray-50 tw-rounded-md tw-text-center tw-bg-gray-200 hover:tw-bg-gray-400 tw-py-20 tw-cursor-pointer"
                onClick={()=>{
                    let newOffset =(Math.floor((offset+1)/4)+1)*4;
                    newOffset = newOffset+4<functionalSkills.length-1?newOffset:functionalSkills.length-4;
                    if(!blockScroll){
                       this.setState({...this.state, offset: newOffset})}
                    }
                }>
                {blockScroll?null:(<p>❯</p>)}
                </div>
        )
    }
    scrollLeftButton(blockScroll){
        const {offset} = this.state
        
        return(
            <div className="tw-text-5xl tw-h-52 tw-w-16 tw-text-gray-300 hover:tw-text-gray-50 tw-rounded-md tw-text-center tw-bg-gray-200 hover:tw-bg-gray-400 tw-py-20 tw-cursor-pointer"
                onClick={()=>{
                    let newOffset = (offset%4!==0)?
                        offset-offset%4:
                        (Math.floor((offset+1)/4)-1)*4;

                    newOffset = newOffset<0?0:newOffset;
                    if(!blockScroll){
                        this.setState({...this.state, offset: newOffset})
                        }
                    }
                }>
                {blockScroll?null:(<p>❮</p>)}
                </div>
        )
    }
    render(){
        const {offset} = this.state;
        const {functionalSkills} = this.props;
        console.log(" ~~~ Functional Skills List:", functionalSkills)
        if(functionalSkills && functionalSkills.length===0){
            return <FunctionalSkillsLoad />
        }
        return(<div className="tw-container tw-mx-10 tw-mt-5  tw-mb-14">
                <div className="tw-my-5"><h1 className="tw-text-gray-900 tw-text-2xl">Functional Skills</h1></div>
                <div className="tw-container tw-mx-auto tw-flex tw-flex-row tw-space-x-4 tw-relative">
                    { this.scrollLeftButton(offset===0) }
                    {
                        functionalSkills.map(
                            (fs, i) => 
                            (i>=offset && i<offset+4)?
                            <FunctionalSkillCard {...fs} index={i}/>: null
                            )
                    }
                    {this.scrollRightButton((functionalSkills.length - offset)<=4)}
                </div>
            </div>)
    }
}

const withState = connect((state)=>{
    const { functionalSkills, user } = state;
    return{ 
        functionalSkills: functionalSkills.functionalSkills,
        token: user.token
    }
})

export default withState(FunctionalSkillsSwimlane)


// WEBPACK FOOTER //
// ./src/components/containers/functional-skills-swimlane/functional-skills-swimlane.js